import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
 *,
 *::after,
 *::before {
   box-sizing: border-box;
 }
 html, body{
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 16px;
    scroll-behavior: smooth;
    font-family: Poppins;
 }
 a{
   text-decoration: none;
 }
 ul{
   list-style-type: none;
 }
  
 .App{
   width: 100%;
   min-height: 100vh;
   position:relative;
   position: relative;
   
 }
//  #root{
//    display: flex;
//    flex-direction: column;
//    min-height: 100vh;
  

//  }
 .main-content{
  flex: 1;
 }
 
.filepond--root {
  font-family: Poppins;
  width: 100%;
}
.filepond--root {
  max-height: 20rem;
}
.filepond--item{
  width: 7em;
}
 `;
